/**
 * Derive a darker shade of a #rrggbb hex (used for brand primary_dark).
 * Returns the input unchanged if it isn't a valid 6-digit hex.
 */
export function darken(hex, amount = 0.18) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
  if (!m) return hex;
  const ch = (h) => Math.max(0, Math.round(parseInt(h, 16) * (1 - amount))).toString(16).padStart(2, '0');
  return `#${ch(m[1])}${ch(m[2])}${ch(m[3])}`;
}
